import ProductEditPage from "../pages/catalog/products/ProductEditPage.vue";
import ProductCreatePage from "../pages/catalog/products/ProductCreatePage.vue";
import InternalProductCustomFieldsPage from "../pages/catalog/products/pages/InternalProductCustomFieldsPage.vue";
import InternalProductPriceTemplatesPage from "../pages/catalog/products/pages/InternalProductPriceTemplatesPage.vue";
import InternalProductAvailabilityPage from "../pages/catalog/products/pages/InternalProductAvailabilityPage.vue";
import PublicationsPage from "../pages/catalog/products/pages/PublicationsPage.vue";
import InternalProductRecommendationsPage from "../pages/catalog/products/pages/InternalProductRecommendationsPage.vue";
import InternalProductGroupProductsPage from "../pages/catalog/products/pages/InternalProductGroupProductsPage.vue";
import InternalProductTypesIndexPage from "../pages/catalog/categories/IndexCategoryPage.vue";
import InternalProductTypeCreatePage from "../pages/catalog/categories/CreateCategoryPage.vue";
import InternalProductTypeEditPage from "../pages/catalog/categories/EditCategoryPage.vue";
import ProductsIndexPage from "../pages/catalog/products/ProductsIndexPage.vue";
import CustomFieldsIndexPage from "../pages/catalog/customFields/CustomFieldsIndexPage.vue";
import CustomFieldCreatePage from "../pages/catalog/customFields/CustomFieldCreatePage.vue";
import CustomFieldEditPage from "../pages/catalog/customFields/CustomFieldEditPage.vue";
import PriceTemplatesIndexPage from "../pages/catalog/priceTemplates/PriceTemplatesIndexPage.vue";
import PriceTemplateCreatePage from "../pages/catalog/priceTemplates/PriceTemplateCreatePage.vue";
import PriceTemplateEditPage from "../pages/catalog/priceTemplates/PriceTemplateEditPage.vue";
import i18n from '../i18n';

const basePath = "/app/projects/:projectUuid/catalog";

const catalogRoutes = [
    {
        path: `${basePath}/product-types`,
        name: "InternalProductTypesIndexPage",
        component: InternalProductTypesIndexPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.Home"), linkName: "Home" },
                    { name: i18n.global.t("pages.InternalProductTypesIndexPage") },
                ]
            }
        }
    },
    {
        name: "InternalProductTypeCreatePage",
        path: `${basePath}/product-types/create`,
        component: InternalProductTypeCreatePage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.Home"), linkName: "Home" },
                    { name: i18n.global.t("pages.InternalProductTypesIndexPage"), linkName: "InternalProductTypesIndexPage" },
                    { name: i18n.global.t("pages.InternalProductTypeCreatePage") }
                ]
            }
        }
    },
    {
        name: "InternalProductTypeEditPage",
        path: `${basePath}/product-types/:categoryUuid`,
        component: InternalProductTypeEditPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.Home"), linkName: "Home" },
                    { name: i18n.global.t("pages.InternalProductTypesIndexPage"), linkName: "InternalProductTypesIndexPage" },
                    { name: i18n.global.t("pages.InternalProductTypeEditPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/products`,
        name: "ProductsIndexPage",
        component: ProductsIndexPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.Home"), linkName: "Home" },
                    { name: i18n.global.t("pages.ProductsIndexPage") },
                ]
            }
        },
    },
    {
        path: `${basePath}/custom-fields`,
        name: "CustomFieldsIndexPage",
        component: CustomFieldsIndexPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.Home"), linkName: "Home" },
                    { name: i18n.global.t("pages.ProductsIndexPage"), linkName: "ProductsIndexPage" },
                    { name: i18n.global.t("pages.IndexCustomFieldsPage") },
                ]
            }
        }
    },
    {
        path: `${basePath}/custom-fields/create`,
        name: "CustomFieldCreatePage",
        component: CustomFieldCreatePage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.Home"), linkName: "Home" },
                    { name: i18n.global.t("pages.ProductsIndexPage"), linkName: "ProductsIndexPage" },
                    { name: i18n.global.t("pages.IndexCustomFieldsPage"), linkName: "CustomFieldsIndexPage" },
                    { name: i18n.global.t("labels.new_custom_field") },
                ]
            }
        }
    },
    {
        path: `${basePath}/custom-fields/:customFieldUuid`,
        name: "CustomFieldEditPage",
        component: CustomFieldEditPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.Home"), linkName: "Home" },
                    { name: i18n.global.t("pages.ProductsIndexPage"), linkName: "ProductsIndexPage" },
                    { name: i18n.global.t("pages.IndexCustomFieldsPage"), linkName: "CustomFieldsIndexPage" },
                    { name: i18n.global.t("labels.custom_field") },
                ]
            }
        }
    },
    {
        path: `${basePath}/price-templates`,
        name: "PriceTemplatesIndexPage",
        component: PriceTemplatesIndexPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.Home"), linkName: "Home" },
                    { name: i18n.global.t("pages.ProductsIndexPage"), linkName: "ProductsIndexPage" },
                    { name: i18n.global.t("pages.PriceTemplatesIndexPage") },
                ]
            }
        }
    },
    {
        path: `${basePath}/price-templates/create`,
        name: "PriceTemplateCreatePage",
        component: PriceTemplateCreatePage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.Home"), linkName: "Home" },
                    { name: i18n.global.t("pages.ProductsIndexPage"), linkName: "ProductsIndexPage" },
                    { name: i18n.global.t("pages.PriceTemplatesIndexPage"), linkName: "PriceTemplatesIndexPage" },
                    { name: i18n.global.t("pages.PriceTemplateCreatePage") },
                ]
            }
        }
    },
    {
        path: `${basePath}/price-templates/:priceTemplateUuid`,
        name: "PriceTemplateEditPage",
        component: PriceTemplateEditPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.Home"), linkName: "Home" },
                    { name: i18n.global.t("pages.ProductsIndexPage"), linkName: "ProductsIndexPage" },
                    { name: i18n.global.t("pages.PriceTemplatesIndexPage"), linkName: "PriceTemplatesIndexPage" },
                    { name: i18n.global.t("pages.PriceTemplateEditPage") },
                ]
            }
        }
    },
    {
        name: "EditProductPage",
        path:  `${basePath}/products/:productUuid`,
        component: ProductEditPage,
        redirect: { name: "PublicationsPage" },
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexProductPage") },
                    { name: i18n.global.t("pages.EditProductPage") }
                ]
            }
        },
        children: [
            {
                name: "InternalProductPricesPage",
                path: "prices",
                component: InternalProductPriceTemplatesPage,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("sidebar.items.prices") }
                        ]
                    }
                }
            },
            {
                name: "InternalProductAvailabilityPage",
                path: "availability",
                component: InternalProductAvailabilityPage,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("sidebar.items.availability") }
                        ]
                    }
                }
            },
            {
                name: "PublicationsPage",
                path: "publications",
                component: PublicationsPage,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("labels.publications") }
                        ]
                    }
                }
            },
            {
                name: "InternalProductRecommendationsPage",
                path: "recommendations",
                component: InternalProductRecommendationsPage,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("sidebar.items.recommendations") }
                        ]
                    }
                }           
            },
            {
                name: "InternalProductGroupProductsPage",
                path: "group-products",
                component: InternalProductGroupProductsPage,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("sidebar.items.groupProducts") }
                        ]
                    }
                }
            }
        ]
    },
    {
        name: "CreateProductPage",
        path: `${basePath}/products/create`,
        component: ProductCreatePage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexProductPage") },
                    { name: i18n.global.t("pages.CreateProduct") }
                ]
            }
        },
        children: []
    }
]

export default catalogRoutes;
